import {
  ContentEditableHtmlEditor as DefaultContentEditableHtmlEditor,
  ContentEditableHtmlEditorOptions as DefaultContentEditableHtmlEditorOptions,
  ContentEditableHtmlEditorServices as DefaultContentEditableHtmlEditorServices,
  createContentEditableHtmlEditor as createDefaultContentEditableHtmlEditor,
} from '@frontapp/editor-html';

import {EmojiMap} from '../../../../services/emojis/emojis';
import {trackCharacterShortcutReplaceEvent} from '../../../../services/tracking/composer';
import {createBlockquoteStylePlugin} from '../plugins/html/blockquoteStylePlugin';
import {createListStylePlugin} from '../plugins/html/listStylePlugin';
import {createInlineAttachmentPlugin} from '../plugins/inlineAttachmentPlugin';
import {createProcessInsertedHtmlPlugin} from '../plugins/processInsertedHtmlPlugin';
import {createCharacterShortcutPlugin} from '../plugins/text/charShortcutPlugin';
import {createEmojiPlugin, EmojiPluginRenderModesEnum} from '../plugins/text/emojiPlugin';
import {createHtmlStyleService} from '../services/htmlStyleService';
import {HtmlStyle} from '../style/htmlStyle';
import {HtmlEditorServices} from './htmlEditor';

export type ContentEditableHtmlEditor = DefaultContentEditableHtmlEditor<
  HtmlEditorServices & DefaultContentEditableHtmlEditorServices
>;

export interface ContentEditableHtmlEditorOptions extends DefaultContentEditableHtmlEditorOptions {
  shouldPasteAsText: boolean;
  defaultStyle?: HtmlStyle;
  emojiValidationMap: EmojiMap;
}

const newListClassName = 'front-editor-new-list';

export function createContentEditableHtmlEditor(
  options: ContentEditableHtmlEditorOptions,
): ContentEditableHtmlEditor {
  const extraPlugins = options.plugins || [];

  return createDefaultContentEditableHtmlEditor(
    {
      // Because our formatting toolbar handles those.
      areStyleKeyboardShortcutsDisabled: true,
      ...options,
      newListClassName,
      plugins: [
        createProcessInsertedHtmlPlugin(),
        createInlineAttachmentPlugin(),
        createEmojiPlugin({
          renderMode: EmojiPluginRenderModesEnum.UNIFIED,
          emojiValidationMap: options.emojiValidationMap,
        }),
        createCharacterShortcutPlugin({
          onReplace: trackCharacterShortcutReplaceEvent,
        }),
        createBlockquoteStylePlugin(),
        createListStylePlugin(newListClassName, options.hasListServiceV2),
        ...extraPlugins,
      ],
      hasListServiceV2: true,
    },
    // Extend with our HtmlStyleService.
    (spec) => ({
      ...spec,
      services: {
        ...spec.services,
        htmlStyle: createHtmlStyleService(spec.services.style, options.defaultStyle),
      },
    }),
  );
}
